module.exports = __webpack_public_path__ + "static/media/regenerate-invoice.8e770412.png";